import dashboardService from '../../../services/dashboardService';
import {
    setStatsLoading,
    setYearlySalesLoading,
    setSalesByLocationLoading,
    setError,
    setStats,
    setYearlySales,
    setSalesByLocation,
    setSelectedYear,
    clearError
} from './dashboardSlice';

// Fetch dashboard statistics
export const fetchStats = () => async (dispatch) => {
    try {
        dispatch(setStatsLoading(true));
        dispatch(clearError());
        
        const response = await dashboardService.getStats();
        dispatch(setStats(response.data || response));
        
        return response;
    } catch (error) {
        console.error('Error fetching dashboard stats:', error);
        const serializedError = {
            message: error.message || 'Failed to fetch dashboard statistics',
            errors: error.errors || {},
            status: error.status || 500
        };
        dispatch(setError(serializedError));
        throw serializedError;
    }
};

// Fetch yearly sales data
export const fetchYearlySales = (year = null) => async (dispatch) => {
    try {
        dispatch(setYearlySalesLoading(true));
        dispatch(clearError());
        
        if (year) {
            dispatch(setSelectedYear(year));
        }
        
        const response = await dashboardService.getYearlySales(year);
        dispatch(setYearlySales(response.data || response));
        
        return response;
    } catch (error) {
        console.error('Error fetching yearly sales:', error);
        const serializedError = {
            message: error.message || 'Failed to fetch yearly sales data',
            errors: error.errors || {},
            status: error.status || 500
        };
        dispatch(setError(serializedError));
        throw serializedError;
    }
};

// Fetch sales by location data
export const fetchSalesByLocation = () => async (dispatch) => {
    try {
        dispatch(setSalesByLocationLoading(true));
        dispatch(clearError());
        
        const response = await dashboardService.getSalesByLocation();
        dispatch(setSalesByLocation(response.data || response));
        
        return response;
    } catch (error) {
        console.error('Error fetching sales by location:', error);
        const serializedError = {
            message: error.message || 'Failed to fetch sales by location data',
            errors: error.errors || {},
            status: error.status || 500
        };
        dispatch(setError(serializedError));
        throw serializedError;
    }
};

// Change selected year
export const changeYear = (year) => (dispatch) => {
    dispatch(setSelectedYear(year));
};

// Clear dashboard error
export const clearDashboardError = () => (dispatch) => {
    dispatch(clearError());
};
